<template>
	<v-dialog :max-width="880" v-model="showPopup" :persistent="true">
		<v-card height="95vh">
			<div class="popup-header">
				<v-icon class="close-icon cursor-pointer" @click="closePopup">{{ closeIcon }}</v-icon>
			</div>
			<v-card-text class="py-0 px-0 pr-3">
				<div class="content-section text-center mt-1 mb-1">
					<v-row>
						<v-col cols="12" md="8" xl="9">
							<v-card flat tile height="95vh" class="twitch-iframe">
								<div class="header"></div>
								<v-card-text class="content">
									<p class="white--text mb-2">
										Subscription checkout should appear in a popup window.
									</p>
									<p class="white--text mb-0">Don't see it?</p>
									<p class="white--text mb-2"><a @click="openWindow" class="pink--text">Click here</a>
										to try
										again.</p>
									<p class="white--text mb-1">Please ensure you are not blocking popup windows.</p>
								</v-card-text>
							</v-card>

						</v-col>
						<v-col cols="12" md="4" xl="3" class="text-center">
							<img src="@/assets/images/logo.png" width="70%" alt="Stream Stickers" srcset="">
							<h2 class="white--text fs--22 fw--400 mb-3">Premium Subscription</h2>

							<img src="@/assets/images/mascot/ShareMascot.png" alt="Stream Stickers" srcset="">

							<div class="mt-5 text-left">
								<h2 class="white--text text-center fs--16 fw--600">Looking to subscribe to</h2>
								<div class="d-flex flex-column justify-center align-center">
									<div class="d-flex justify-center align-center my-3">
										<span class="yellow--text fs--22 fw--600">Tier 2</span>
										<span class="fieldFore--text fs--14 fw--800 px-2">or</span>
										<span class="pink--text fs--22 fw--600">Tier 3</span>
										<span class="fieldFore--text fs--18 fw--600 ml-1">?</span>
									</div>
									<p>Be sure to select the "<span class="blueWaves--text">Elevate your
											Subscription</span>" button in the popup checkout window.</p>
								</div>
							</div>
						</v-col>
					</v-row>
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { computed, watch } from '@vue/composition-api';
import { mdiClose, mdiChevronRight } from '@mdi/js';
export default {
	props: {
		modal: {
			type: Boolean,
			default: false,
		},
		plan: {
			type: Object,
			default: null,
		},
		current: {
			type: Object,
			default: null,
		}
	},
	setup(props, { emit }) {
		const showPopup = computed({
			get() {
				return props.modal;
			},
			set(newValue) {
				if (!newValue) {
					emit('close', true);
				}
			},
		});

		watch(showPopup, () => {
			if (showPopup.value) {
				setTimeout(() => {
					openWindow()
				}, 250);
			}
		})

		const openWindow = () => {
			const div = document.querySelector('.twitch-iframe');
			const rect = div.getBoundingClientRect();

			const extra = 159;

			const left = rect.left;
			const top = rect.top + extra;
			const height = rect.height - (extra / 2) + 20;

			const url = 'https://www.twitch.tv/subs/streamstickers';

			window.open(url, 'PopupWindow', `width=${rect.width},height=${height},left=${left},top=${top}`)
		}

		const closePopup = () => {
			emit('close', true);
		};
		return {
			openWindow,
			closePopup,
			showPopup,
			closeIcon: mdiClose,
			chevron: mdiChevronRight
		};
	},
};
</script>

<style lang="scss" scoped>
.popup-header {
	position: relative;
	padding: 12px 0;
	height: 50px;
	background: url('../../../assets/images/backgrounds/sticker-upload-header.png');
	background-repeat: no-repeat;
	background-size: cover;
}

.close-icon {
	position: absolute;
	top: 15px;
	right: 15px;
}

.content-section {
	width: 100%;
	margin: auto;
	// overflow-y: scroll;
	// overflow-x: hidden;
	// scrollbar-width: 4px;
	// scrollbar-color: var(-v--pink-base);

	.twitch-iframe {
		border-radius: 8px !important;

		.header {
			background: #18181B !important;
			height: 52px;
		}

		.content {
			height: 100%;
			display: flex;
			flex: 1;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			@media screen and (max-width: 965px) {
				min-height: 500px !important;
			}
		}

		display: flex;
		flex-direction: column;
		margin-top: -54px;
		background: #1F1F23 !important;
		box-shadow: 5px 0px 30px black !important;
	}
}
</style>
